import { useEffect, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileContract, faCheck } from "@fortawesome/free-solid-svg-icons";

import { useContracts } from "../../Context/ContractContext";

/**
 * محدّد العقد النشط.
 *
 * لا يظهر لمن له عقد واحد: سؤاله عن عقده الوحيد ضجيج، والخادم يختاره له
 * تلقائياً. ولا يظهر لمن لا عقد له أصلاً.
 */
export function ContractSwitch() {
  const { contracts, activeContractId, activeContract, showSelector, setActiveContract } =
    useContracts();

  const [open, setOpen] = useState(false);
  const boxRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;

    const close = (event) => {
      if (boxRef.current && !boxRef.current.contains(event.target)) setOpen(false);
    };

    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, [open]);

  if (!showSelector || contracts.length === 0) return null;

  const label = activeContract?.name || activeContract?.contractNumber || "اختر عقداً";

  return (
    <div className="ah-contract" ref={boxRef}>
      <button
        type="button"
        className="ah-contract__trigger"
        onClick={() => setOpen((v) => !v)}
        aria-haspopup="listbox"
        aria-expanded={open}
        title={activeContract?.contractNumber ? `رقم العقد: ${activeContract.contractNumber}` : "العقد النشط"}
      >
        <FontAwesomeIcon icon={faFileContract} className="ah-contract__icon" />
        <span className="ah-contract__label">{label}</span>
      </button>

      {open && (
        <ul className="ah-menu ah-contract__menu" role="listbox">
          {contracts.map((contract) => {
            const isActive = contract.id === activeContractId;

            return (
              <li key={contract.id}>
                <button
                  type="button"
                  role="option"
                  aria-selected={isActive}
                  className={`ah-contract__item ${isActive ? "ah-contract__item--active" : ""}`}
                  onClick={() => {
                    setOpen(false);
                    // التبديل إلى العقد نفسه لا يستحقّ إعادة تحميل.
                    if (!isActive) setActiveContract(contract.id);
                  }}
                >
                  <span className="ah-contract__name">
                    {contract.name || contract.contractNumber}
                  </span>
                  {contract.contractNumber && (
                    <span className="ah-contract__number">{contract.contractNumber}</span>
                  )}
                  {isActive && (
                    <FontAwesomeIcon icon={faCheck} className="ah-contract__check" />
                  )}
                </button>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}
